import { render, staticRenderFns } from "./CreateFolderModal.vue?vue&type=template&id=4f75ab5c&"
import script from "./CreateFolderModal.vue?vue&type=script&lang=ts&"
export * from "./CreateFolderModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2898369969/src/github.com/trainn-tech/trainn-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f75ab5c')) {
      api.createRecord('4f75ab5c', component.options)
    } else {
      api.reload('4f75ab5c', component.options)
    }
    module.hot.accept("./CreateFolderModal.vue?vue&type=template&id=4f75ab5c&", function () {
      api.rerender('4f75ab5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/modals/CreateFolderModal.vue"
export default component.exports